import { Model } from "@quest/murka-games-behavior-panther/dist"

export class BaseGameModel extends Model {

  protected cascadeSequence: string[] = ["checkForReveal", "showCascadingWin", "startNextLineToggle", "startNextCascade","checkForReveal","checkForWinAndSendClose"]
  private cascadeSequenceCounter: number = 0;

  constructor(serverModel: any) {
    super(serverModel);
    this.setAnimationSequence(["bigWin", "baitReveal", "respinTriggeringAnimation" ,"ShowFishRespin", "freeSpin", "sendCloseRequest"]);
  }
  
  public getCascadeSequence(): string[] {
    return this.cascadeSequence;
  }
  public setCascadeSequenceCounter(value: number) {
    this.cascadeSequenceCounter = value;
  }
  public updateCascadeSequenceCounter() {
    this.cascadeSequenceCounter++;
  }
  public getCascadeSequenceCounter():number {
    return this.cascadeSequenceCounter;
  }

}

